// extracted by mini-css-extract-plugin
export default {"navbar":"navbar-module--navbar--55017","content":"navbar-module--content--b2c1e","fullWidth":"navbar-module--fullWidth--6dac8","logo":"navbar-module--logo--a4da1"};